import { AngledMarquee } from "@/components/layout/AngledMarquee";

/**
 * Angled scrolling marquee just below the footer's diagonal top edge.
 * White text on the black footer, fades at both ends, tilts to match the
 * footer angle at any screen size, editable in-place by admins (text + link).
 */
export const FooterMarquee = () => (
  <AngledMarquee
    textField="footer_marquee_text"
    enabledField="footer_marquee_enabled"
    linkField="footer_marquee_link_url"
    targetField="footer_marquee_link_target"
    durationField="footer_marquee_duration"
    outerClassName="absolute inset-x-0 top-0 z-[2] h-[104px] overflow-hidden"
    textClassName="text-white"
    textMarginTop={38}
    editLabel="Edit banner"
    testIds={{
      container: "footer-marquee",
      input: "marquee-input",
      linkInput: "marquee-link-input",
      target: "marquee-target",
      speed: "marquee-speed",
      save: "marquee-save",
      cancel: "marquee-cancel",
      edit: "marquee-edit",
      link: "marquee-link",
    }}
  />
);
